/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-17 11:41:08
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-04 20:47:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/tools/commonDataCheck/advancedPrice.ts
 */
import _ from 'lodash';

//import { generateErrorKey } from 'src/tools/helper';

export const checkAdvancedPrice = (advancedPriceSettings) => {
  const data = _.cloneDeep(advancedPriceSettings || []);
  const flag = false;
  data.forEach((i) => {
    //const { price } = i || {};
    // if (!title) {
    //   i[generateErrorKey('title')] = true;
    //   flag = true;
    // }
    // if (!price) {
    //   i[generateErrorKey('price')] = true;
    //   flag = true;
    // }
    // if (!currency) {
    //   i[generateErrorKey('currency')] = true;
    //   flag = true;
    // }
  });
  return { flag, data };
};
